import React from "react";
import styles from "./Publicite.module.css";
import Diapositive from "./Diapositive";
import {diapositivesAffichees, LIMITES, suivante} from "./diaporama";
import {idsFondsAnimes} from "./fondsAnimes";

/** Sécurité d'une vidéo jouée en entier : si elle ne signale jamais sa fin (fichier abîmé), on passe à la suite. */
const VIDEO_MAXIMUM_MS = LIMITES.duree.max * 1000;
/** Durée du fondu entre deux diapositives (celle de l'animation « apparition » du CSS), plus une marge. */
const FONDU_MS = 1000;

/**
 * Diaporama du mode Publicité : les diapositives actives passent l'une après l'autre, chacune pendant sa durée (ou jusqu'à
 * la fin de sa vidéo), puis on recommence. Un seul minuteur, relancé à chaque diapositive. La diapositive qui s'en va reste
 * dessous le temps du fondu, pour que la suivante apparaisse par-dessus elle (et non sur un fond uni).
 *
 * @param diapositives  diapositives normalisées (diaporama.js)
 * @param base          adresse du serveur, devant celle des images et vidéos
 * @param fondProps     fonction (identifiant d'un fond animé) → propriétés de ce fond (images, réglages, horaires du bandeau)
 * @param depart        (aperçu) index de la diapositive par laquelle commencer
 * @param boucle        faux : s'arrête sur la dernière diapositive (aperçu d'une seule diapositive)
 * @param style         style de l'enveloppe (aperçu à taille réelle)
 */
export default class Diffusion extends React.Component {

    state = {index: this.props.depart || 0, tour: 0, precedente: null};

    componentDidMount() {
        this.programmer();
    }

    componentDidUpdate(avant, etatAvant) {
        if (etatAvant.index !== this.state.index || etatAvant.tour !== this.state.tour || avant.diapositives !== this.props.diapositives) {
            this.programmer();
        }
    }

    componentWillUnmount() {
        window.clearTimeout(this.minuteur);
        window.clearTimeout(this.minuteurFondu);
    }

    liste() {
        return diapositivesAffichees(this.props.diapositives || [], idsFondsAnimes());
    }

    actuelle() {
        const liste = this.liste();
        return liste.length ? liste[Math.min(this.state.index, liste.length - 1)] : null;
    }

    programmer() {
        window.clearTimeout(this.minuteur);
        const diapositive = this.actuelle();
        if (!diapositive) return;
        const videoEntiere = diapositive.fond.type === "video" && diapositive.video_entiere;
        this.minuteur = window.setTimeout(this.passer, videoEntiere ? VIDEO_MAXIMUM_MS : diapositive.duree * 1000);
    }

    passer = () => {
        const nombre = this.liste().length;
        if (this.props.boucle === false && this.state.index >= nombre - 1) return;
        const actuelle = this.actuelle();
        // le tour change aussi : avec une seule diapositive, elle est remontée et ses textes rejoués
        this.setState(({index, tour}) => ({
            index: suivante(Math.min(index, nombre - 1), nombre),
            tour: tour + 1,
            precedente: actuelle ? {diapositive: actuelle, cle: this.cle(actuelle, tour)} : null,
        }));
        window.clearTimeout(this.minuteurFondu);
        this.minuteurFondu = window.setTimeout(() => this.setState({precedente: null}), FONDU_MS);
    };

    cle(diapositive, tour) {
        return diapositive.id + "-" + tour;
    }

    dessiner(diapositive, cle, enCours) {
        const {base, fondProps} = this.props;
        return (
            <Diapositive key={cle} diapositive={diapositive} base={base}
                         fondProps={fondProps ? fondProps(diapositive.fond.anime) : {}} onFinVideo={enCours ? this.passer : undefined}/>
        );
    }

    render() {
        const diapositive = this.actuelle();
        const {precedente, tour} = this.state;
        const {style} = this.props;

        return (
            <div className={styles.ecran} style={style}>
                {diapositive ? [
                    precedente && precedente.cle !== this.cle(diapositive, tour) && this.dessiner(precedente.diapositive, precedente.cle),
                    this.dessiner(diapositive, this.cle(diapositive, tour), true),
                ] : (
                    <div className={styles.accueil}>
                        <h1>Bienvenue chez AkitaTek</h1>
                        <p>Nous réparons vos consoles de jeux et ordinateurs</p>
                    </div>
                )}
            </div>
        );
    }
}
